/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * Hides the Google reCAPTCHA badge by injecting a style tag into the document's body.
 *
 * @param {none} - This function does not take any parameters.
 * @return {void} This function does not return a value.
 */
export function hideRecaptchaBadge() {
    const style = document.createElement('style');
    style.innerHTML = '.grecaptcha-badge{visibility: hidden !important;}';
    document.body.appendChild(style);
}
